import Repository from '../../repositories/RepositoryFactory';
const licensesRepository = Repository.get('licenses');

export default {
	namespaced: true,
	state: {
		licenses: [],
		selectedLicense: {},
	},
	mutations: {
		GET_LICENSES (state, payload) {
			state.licenses = payload;
		},
		GET_LICENSE_ORGANIZATION (state, payload) {
			state.selectedLicense = payload;
		},
	},
	actions: {
		async getLicenses ({ commit }) {
			commit('GET_LICENSES', await licensesRepository.getLicenses());
		},
		async getLicenseForOrganization ({ commit }, body) {
			commit('GET_LICENSE_ORGANIZATION', await licensesRepository.getLicenseForOrganization(body));
		},
		async addLicense ({ commit }, body) {
			const res = await licensesRepository.addLicense(body);
			return res.data;
		},
		async editLicensesForOrganization ({ commit }, body) {
			const res = await licensesRepository.editLicensesForOrganization(body);
			return res.data;
		},
		async addBulkLicenses ({ commit }, body) {
			const res = await licensesRepository.addBulkLicenses(body);
			return res.data;
		},
		async deleteLicense ({ commit }, body) {
			const res = await licensesRepository.deleteLicense(body);
			return res.data;
		},
		async getLicenseAssignmentsForPatient ({ commit }, body) {
			const res = await licensesRepository.getLicenseAssignmentsForPatient(body);
			return res.data;
		},
		async assignLicenseForPatient ({ commit }, body) {
			const res = await licensesRepository.assignLicenseForPatient(body);
			return res.data;
		},
		async deassignLicenseForPatient ({ commit }, body) {
			const res = await licensesRepository.deassignLicenseForPatient(body);
			return res.data;
		},
	},
};
